import { render, staticRenderFns } from "./PreTests.vue?vue&type=template&id=2237027f&"
import script from "./PreTests.vue?vue&type=script&lang=js&"
export * from "./PreTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports